import * as z from "zod/v4";

export const getAmazonAuthUrl = {
  name: "getAmazonAuthUrl" as const,
  input: z.object({}),
  output: z.object({ authUrl: z.string() }),
};
